import type { ReactNode } from 'react';
import { Header, type AppView } from './Header';

interface AppShellProps {
  onRefresh: () => void;
  isLoading: boolean;
  view: AppView;
  onViewChange: (view: AppView) => void;
  children: ReactNode;
}

export function AppShell({ onRefresh, isLoading, view, onViewChange, children }: AppShellProps) {
  return (
    <div className="app-shell">
      <Header onRefresh={onRefresh} isLoading={isLoading} view={view} onViewChange={onViewChange} />
      <main className="app-shell__main">{children}</main>
    </div>
  );
}
